export const REAL_IMAGE_PATH = process.env.IMG_PATH;

export function uploadFileToS3(
  file,
  s3key,
  s3bucketUrl,
  s3fields,
  callbackSuccess,
  reject = null,
  baseRepositoryUrl = REAL_IMAGE_PATH
) {
  const fd = new FormData();
  fd.append('key', s3key);
  fd.append('acl', 'public-read');
  fd.append('success_action_status', '201');
  let fileType = 'image/jpeg';
  if (file.type && file.type !== '') {
    fileType = file.type;
  }
  fd.append('Content-Type', fileType);
  fd.append('X-Amz-Credential', s3fields['X-Amz-Credential']);
  fd.append('X-Amz-Algorithm', s3fields['X-Amz-Algorithm']);
  fd.append('X-Amz-Date', s3fields['X-Amz-Date']);
  fd.append('X-Amz-Security-Token', s3fields['X-Amz-Security-Token']);
  fd.append('Policy', s3fields.Policy);
  fd.append('X-Amz-Signature', s3fields['X-Amz-Signature']);
  fd.append('file', file);

  const xhr = new XMLHttpRequest();

  xhr.addEventListener(
    'load',
    () => {
      // onSuccess
      let finalPath = `${baseRepositoryUrl}/${s3key}`;
      if (callbackSuccess) {
        if (s3fields.bucket) {
          finalPath = `https://${s3fields.bucket}/${s3key}`;
        }
        callbackSuccess(finalPath);
      } else {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xhr.responseText, 'text/xml');
        const code = xmlDoc.getElementsByTagName('Code')[0]?.textContent;
        const message = xmlDoc.getElementsByTagName('Message')[0]?.textContent;
        const error = { code, message };
        if (reject) reject(error);
      }
    },
    false
  );
  xhr.open('POST', s3bucketUrl, true); // MUST BE LAST LINE BEFORE YOU SEND

  xhr.send(fd);
}
